export const systemLanguages = [
  {value: "en", label: "English (US)"},
  {value: "ja", label: "日本"},
  {value: "ko", label: "한국인"},
  {value: "zh", label: "普通話"},
]
